const sr = {
  heroTitle: "Bovansko Jezero",
  home: 'Početna',
  contact: 'Kontakt',
  apartments: 'Apartmani',
  about: 'O Bovanskom jezeru',
  more: 'Više',
  button: 'Rezerviši sada',
  aboutHeader: 'Bovansko jezero - Skriveni dragulj istočne Srbije',
  aboutFirstTitle: 'Bovansko jezero - Oaza mira i prirodne lepote',
  aboutFirstSlide: 'Bovansko jezero, skriveno u srcu Srbije, prava je oaza mira i prirodne lepote. Smešteno između Aleksinca i Sokobanje, ovo jezero privlači pažnju svojim kristalno čistom vodom i netaknutom prirodom. Idealan je za one koji žele da pobegnu od gradske vreve i pronađu mir u prirodi',
  aboutSecondTitle: 'Veštačko jezero sa prirodnom lepotom',
  aboutSecondSlide: 'Iako se radi o veštačkom jezeru nastalom 1978. godine izgradnjom brane na reci Moravici, može se reći da je prirodna lepota istočne Srbije. Dugačko je oko osam kilometara, pa za one koji ne mogu da priušte odlazak na more, može da bude adekvatna zamena. Brana je napravljena sa ciljem zaštite od poplava, ali je jezero koje se oformilo vremenom postalo centar za rekreaciju i turizam.',
  aboutThirdTitle: 'Rekreacija i avantura na jezeru',
  aboutThirdSlide: 'Kada se prvi put ugleda Bovansko jezero, prvo što se primeti je neverovatna boja vode, koja se menja od smaragdno zelene do duboko plave, zavisno od svetlosti i godišnjeg doba. Okruženo šumovitim brdima i bujnom vegetacijom, jezero nudi brojne mogućnosti za rekreaciju i avanturu, kao što su ribolov, plivanje, jedrenje, kajak i biciklizam.',
  aboutFourthTitle: 'Lokalni specijaliteti i uživanje u prirodi',
  aboutFourthSlide: 'Poseta Bovanskom jezeru nije potpuna bez degustacije lokalnih specijaliteta. U obližnjim selima možete uživati u domaćim proizvodima, poput sira, meda i rakije. Restorani u okolini nude tradicionalna jela kao što su jagnjetina ispod sača i razne vrste pastrmki. Ovo je savršena destinacija za spoj avanture, odmora i prirodne lepote.',
  apartmentFeature: "Istaknut",
  apartmentFrom: "od",
  apartmentPrice: "noć",
  reccomendedTitle: "Bella Apartmani",
  reccomendedDescription: "Dosta vam je punih plaža? Tražite mir i prirodu? Tražite nešto potpuno drugačije? Imamo idealno rešenje za vas!",
  commonQuestionTitle: "Česta pitanja",
  testimonialsTitle: "Šta naši gosti kažu",
  contactTitle: "Kontaktirajte nas",
  contactSecondTitle: "Uživajte u miru I lepoti Bovanskog jezera. Bella apartmani pružaju savršenu kombinaciju komfora I prirodnog okruženja za opuštajući odmor. Rezervišite sada!",
  contactName: "Ime",
  contactMessage: "Poruka",
  contactSuccess: "Poruka je uspešno poslata!",
  contactFail: "Došlo je do greške pri slanju poruke.",
  contactSending: "Šalje se...",
  contactSend: "Pošaljite poruku",
  contactInformation: "Kontakt informacije",
  footerDescription: "Savremeni apartmani na Bovanskom jezeru, sa mirnim okruženjem i prelepim pogledom na jezero. Porodični sadržaji uključuju prostrano dvorište, ležaljke, kajak, čamac, roštilj i još mnogo toga za opuštajući boravak.",
  footerFirstTitle: "UKRATKO",
  footerSecondTitle: "KONTAKT INFORMACIJE",
  footerThirdTitle: "BRZI LINKOVI",
  welcomeTitle: "Dobrodošli u život na jezeru",
  welcomeDescription:
    "Otkrijte savršenu kombinaciju luksuza i prirode u našim apartmanima uz jezero, gde svaki izlazak sunca donosi nove mogućnosti za uživanje pored vode.",
  section1Title: "Bovansko Jezero: Oaza Mira i Prirodne Lepote",
  section1Description: "Skriveno u srcu Srbije, Bovansko jezero je idealno mesto za beg od gradske vreve, sa kristalno čistom vodom i netaknutom prirodom.",
  feature1Title: "Nastanak i istorija",
  feature1Description: "Veštačko jezero nastalo izgradnjom brane na reci Moravici 1978. godine, dugačko osam kilometara, nudi rekreaciju i prirodnu lepotu istočne Srbije.",
  feature2Title: "Boja Vode i Šume",
  feature2Description: "Nevjerovatna boja vode, od smaragdno zelene do duboko plave, i guste šume stvaraju savršen ambijent za uživanje.",
  feature3Title: "Rekreativne Aktivnosti",
  feature3Description: "Ribolov, plivanje, jedrenje, planinarenje, biciklizam, vožnja kajakom i pedaline su samo deo mogućnosti koje jezero nudi.",
  
  feature4Title: "Mesta i atrakcije u blizini",
  feature4Description: "Sokobanja je udaljena 17 km od Bella apartmana.\n Bella apartmani su udaljeni 48km od Niškog aerodroma.",
  
  feature5Title: "Izletišta",
  feature5Description: "Lepterija i Soko Grad\n Ripaljka vodopad \n Izvor reke Moravice\n Vrmdzansko jezero\n Restoran ''Etno vodenica kod deda Mije''\n Sesalačka pećina\n Park Borici\n Plaže za kupanje na reci Moravici\n Plaža ''Dzentlmen''",
  
  feature6Title: "Restorani u Sokobanji",
  feature6Description: "Zelengora\nRestoran Stankovič\nPicerija Lav\nLa Famiglia Sokobanja\nRestoran Župan\nRestoran Milošev Konak\n️Restoran Stara vodenica\n️Kafana Kod Kuma\n️Kod Pudle\n️Vodenica kod deda Mije\n️Filotin pogled",
  
  
  section2Title: "Plaže i Okolina",
  section2Description: "Čiste plaže bez infrastrukture, negovane od strane lokalnog stanovništva, pružaju poseban ambijent za uživanje.",
  excellenceTitle: "Lokalna Gastronomija",
  excellenceDescription: "Tradicionalna jela, domaći proizvodi poput sira, meda i rakije čine posetu Bovanskom jezeru nezaboravnom.",
  holidayPeriod: "Praznični Period",
  regularPeriod: "Sezonski Period",
  nonRegularPeriod: "Van Sezonski Period",
  holidayDates: ["30.12 - 02.01" , "01.05" , "14.02" , "11.11"], 
  holidayPrice: "€300",
  regularNightPrice: "€50",
  nonRegularNightPrice: "€40",
  weekendPrice: "€130",
  checkIn: "12:00 prijava",
  checkOut: "15:00 odjava",
  weekendTime: "Pet 14:00 - Ned 18:00",
  twoBedrooms: "Dve Spavaće Sobe",
  groundFloorApartmentDescription: "Dnevna soba sa sofom na razvlačenje, spavaća soba sa bračnim krevetom, kupatilo, kuhinja sa barom, i terasa sa pogledom na jezero.",
  upperFloorApartmentDescription: "Dve spavaće sobe (bračni + odvojeni kreveti), kupatilo, kuhinja i terasa sa pogledom na jezero.",
  firstTestimonialName: "Sara",
  firstTestimonialImage: "first",
  firstTestimonialText: "Prelep odmor na Bovanskom jezeru, apartmani su udobni i mirni.",

  secondTestimonialName: "Mihajlo",
  secondTestimonialImage: "second",
  secondTestimonialText: "Idealno mesto za opuštanje, blizu prirode i jezera.",

  thirdTestimonialName: "Marija",
  thirdTestimonialImage: "third",
  thirdTestimonialText: "Preporučujem za miran i udoban odmor u prelepoj prirodi.",

  fourthTestimonialName: "Danilo",
  fourthTestimonialImage: "fourth",
  fourthTestimonialText: "Savršeno mesto za porodični odmor, blizu jezera i prirode.",
  amenities: "Istaknut sadržaj",
  aboutProperty: "O ovoj nekretnini",
  groundFloorApartmentTitle: "App Bella Prizemlje",
  upperFloorApartmentTitle: "App Bella Sprat"
};

export default sr;
